<style src="@/assets/styles/components/modules/hosted-pages/subscribe.styl" lang="stylus" scoped></style>
<template>
  <div :class="customClass">
    <slot name="consent"></slot>
    <slot name="notes"></slot>
    <div class="cb-subscribe" v-if="legal_agreements_enabled">
      <!-- Loop through each legal agreement -->
      <div v-for="(agreement, index) in legal_agreements" :key="index" class="cb-check cb-check--box cb-check--text">

        <!-- Render checkbox if show_checkbox is true -->
        <div class="cb-check__block">
        <input type="checkbox" ref="x" class="cb-subscribe__check" v-if="agreement.take_consent"
          @change="updateLegalTerms($event)" @keyup.enter="next()" :id="'tos_agreed_' + index" aria-required="true"/>
        </div>

        <!-- Render label with dynamic content -->
        <label class="cb-subscribe__label"
          :class="{ 'mandate': agreement.take_consent }"
          :for="'tos_agreed_' + index" v-cb-html="getReplacements(agreement.agreement_text)">
        </label>
      </div>
    </div>
    <cb-button v-if="btn_hide" :custom-class="'primary'" :show-loader="showLoader"
      :class="{ 'cb-button__disabled': btn_disabled }" :aria-disabled="disableButton" :btnDisabled="disableButton"
      :disabled="disableButton" @next="submit()" :attr="'review_submit'">
      {{ getButtonTxt }}
    </cb-button>
    <div v-if="btn_hide" class="cb-subscribe cb-subscribe__footer"><i class="icon-lock" aria-hidden="true"></i>
    {{st('checkout_message')}} <template v-if="!hideBranding">{{st('chargebee_checkout')}}</template>
    </div> 
    <overlay-loader :visible="overlayVisible" :submitPayment="submitPayment" />
  </div>
</template>
<script type="text/javascript">
import ButtonComponent from "@/components/collections/form/ButtonComponent";
import OverlayLoader from "@/components/modules/hosted-pages/OverlayLoader";
import { mapGetters } from "vuex";
import UpdateSubUtils from "@/utils/update-sub"
export default {
  props: ["showLoader", "customClass", "txtKey", "total", "hideButtonOverride", "disableAction"],
  components: {
    "cb-button": ButtonComponent,
    "overlay-loader": OverlayLoader,
  },
  data() {
    return {
      transformedContent: {},
      hideBranding: false,
      agreed_legal_terms: 0,
      overlayVisible: false,
    };
  },
  mounted() {
    this.hideBranding =
      window && window.initInfo && window.initInfo.hide_branding;
    const count = this.legal_agreements.filter(agreement => agreement.take_consent).length;
    if(this.agreed_legal_terms == count){
      this.$store.dispatch("set_tos_agreed", true);
    }else{
      this.$store.dispatch("set_tos_agreed", false);
    }
  },
  computed: {
    ...mapGetters([
      "tos_holder",
      "currency_code",
      "amount_due",
      "current_amount_due",
      "tos_enabled",
      "legal_agreements_enabled",
      "legal_agreements",
      "pm_consent",
      "is_ideal_payment",
    ]),
    // isConsentMandatory: this.$slots && this.$slots['consent'] && this.is_tos_cbx_showed(),
    tos_agreed: {
      get() {
        return this.$store.getters.tos_agreed;
      },
      set(value) {
        this.$store.dispatch("set_tos_agreed", value);
      }
    },
    btn_disabled() {
      return this.legal_agreements_enabled && !this.tos_agreed;
    },
    btn_hide() {
      return !this.hideButtonOverride;
    },
    getButtonTxt() {
      if (!this.txtKey && !this.total) { //if both txt and total are not passed as props
        if (this.$store.getters.translate("review.btn.txt")) { //for hpv3 settings version upto 2
          return this.t("review.btn.txt", { amount: this.$options.filters.cbCurrency(this.amount_due, this.currency_code) });
        }
        if (this.current_amount_due > 0
          && !(UpdateSubUtils.isCheckoutExisting() && UpdateSubUtils.isScheduledChange())) {
          return this.t("review.subscribe_btn.current_charge_present.txt", { amount: this.$options.filters.cbCurrency(this.current_amount_due, this.currency_code) });
        } else {
          return this.t("review.subscribe_btn.current_charge_zero.txt", { amount: this.$options.filters.cbCurrency(this.current_amount_due, this.currency_code) });
        }
      }
      return this.t(this.txtKey, { amount: this.$options.filters.cbCurrency(this.total, this.currency_code) });
    },
    disableButton() {
      return this.btn_disabled || this.disableAction || !this.pm_consent;
    }
  },
  methods: {
    sanitizeLineBreaks(content) {
      return {
        text: content,
        tags: ["div"],
        attrs: {}
      };
    },
    updateLegalTerms(e) {
      if (e.target.checked)
        this.agreed_legal_terms++
      else
        this.agreed_legal_terms--
      const count = this.legal_agreements.filter(agreement => agreement.take_consent).length;
      if(this.agreed_legal_terms == count){
        this.$store.dispatch("set_tos_agreed", true);
      }else{
        this.$store.dispatch("set_tos_agreed", false);
      }
    },
    getReplacements(htmlString) {
      if (!htmlString) return '';

      const beId = this.$store.getters.business_entity_id;
      const locale = this.$store.getters.init_info_locale;

      // Replace all instances of {{locale}} (since it's always defined)
      htmlString = htmlString.replace(/{{locale}}/g, locale);

      // Replace all instances of {{entity_id}} only if beId is defined
      if (beId) {
        htmlString = htmlString.replace(/{{entity_id}}/g, beId);
      }

      // Ensure all <a> tags have target="_blank", even if there are multiple <a> tags
      htmlString = htmlString.replace(/<a(?![^>]*target=)/g, '<a target="_blank"');

      return htmlString;
    },
    next() {
      this.$refs.x.click();
    },
    submit() {
      if (this.is_ideal_payment) {
        this.overlayVisible = true;
      } else {
        this.submitPayment();
      }
    },

    submitPayment() {
      this.overlayVisible = false;
      if (this.tos_agreed || !this.legal_agreements_enabled ) {
        this.$emit("submit");
      }
    },
  }
};

</script>

<style lang="stylus" scoped>
.cb-subscribe{
	&__{
		&check {
			margin-top:0;
			width:16px;
			height: 16px;
		}
	}
}
.mandate{
    color: text_primary;
    font-weight: normal ;
    vertical-align: middle;
    &:after{
        content: "*";
        color: #D02A20;
        font-size: 14px;
    }
}
.cb-check{
  &--{
    &text {
      text-align: start;
    }
  }
}
</style>